import {
  AcademicCapIcon,
  BriefcaseIcon,
} from "@heroicons/react/20/solid";


export default function About() {
  return (
    <div
      className="relative isolate overflow-hidden  px-6 py-12 sm:py-16 lg:overflow-visible lg:px-0"
      id="about"
    >
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="text-base leading-7">
            <div className="grid gap-x-6 sm:grid-cols-1">
              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl w-full max-w-4xl mx-auto"
                data-aos="zoom-in"
              >
                <BriefcaseIcon className="h-5 w-5 mx-auto" aria-hidden="true" />
                <h2 className=" text-2xl text-center font-bold tracking-tight pb-3">
                  Experience
                </h2>
                <h3 className="text-xl font-bold">
                  Shopee
                </h3>
                <h3 className="text-l">
                  Regional Product Intern
                </h3>
                <h3 className="text-l text-gray-500">
                  Singapore, Dec 2025 - Present
                </h3>
                <p className="mt-3 list-item list-inside">
                Planning and coordinating end-to-end feature rollout in the User and Notification team across SEA, Taiwan and LATAM markets
                </p>
              </div>

              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl w-full max-w-4xl mx-auto"
                data-aos="zoom-in"
              >
                <BriefcaseIcon className="h-5 w-5 mx-auto" aria-hidden="true" />
                <h2 className=" text-2xl text-center font-bold tracking-tight pb-3">
                  Experience
                </h2>
                <h3 className="text-xl font-bold">
                  HungryHub
                </h3>
                <h3 className="text-l">
                  Software Engineer Intern
                </h3>
                <h3 className="text-l text-gray-500">
                  Thailand, June 2025 - August 2025
                </h3>
                <p className="mt-3 list-item list-inside">
                Developed and iterated on full stack applications using Ruby on Rails, Tailwind CSS, Redis, ElasticSearch
                </p>
                <p className="mt-3 list-item list-inside">
                Delivered end-to-end proof of concept API integrations with partners such as Klook, OpenRice and Traveloka to reduce manual data exchange and support tickets
                </p>
              </div>
              
              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl w-full max-w-4xl mx-auto"
                data-aos="zoom-in"
              >
                <BriefcaseIcon className="h-5 w-5 mx-auto" aria-hidden="true" />
                <h2 className=" text-2xl text-center font-bold tracking-tight pb-3">
                  Experience
                </h2>
                <h3 className="text-xl font-bold">
                  RegTech.ID
                </h3>
                <h3 className="text-l">
                  Data Engineer Intern
                </h3>
                <h3 className="text-l text-gray-500">
                  Indonesia, May 2024 - August 2024
                </h3>
                <p className="mt-3 list-item list-inside">
                Implemented an automated web scraper tracking changes in financial regulatory policy for 1500+ documents
                </p>
                <p className="mt-3 list-item list-inside">
                Planned the logical database design for a proprietary document management system
                </p>
                <p className="mt-3 list-item list-inside">
                Built CRUD APIs to pipeline context information to LLM models
                </p>
                <div className="mt-3 flex items-center gap-2 list-inside">
                  <a
                    href="https://www.linkedin.com/posts/rika-astari-61a6a671_smuaip-activity-7233647992266711040-9uEC/?utm_source=share&utm_medium=member_desktop&rcm=ACoAADbXRSkBzdLoeJyV5N_oupqvcR3Cp64GzNE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    Founder's Note
                  </a>
                  <a
                    href="https://www.linkedin.com/posts/rika-astari-61a6a671_smuaip-activity-7233647992266711040-9uEC/?utm_source=share&utm_medium=member_desktop&rcm=ACoAADbXRSkBzdLoeJyV5N_oupqvcR3Cp64GzNE"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn btn-outline btn-square btn-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="h-5 w-5"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                      </svg>
                    </button>
                  </a>
                </div>
              </div>
              <div
                className="ring-2 ring-base-300 bg-base-200 rounded-2xl mt-10 p-5 shadow-xl w-full max-w-4xl mx-auto"
                data-aos="zoom-in"
              >
                <AcademicCapIcon
                  className="h-5 w-5 mx-auto"
                  aria-hidden="true"
                />
                <h2 className=" text-2xl text-center font-bold tracking-tight pb-3">
                  Education
                </h2>
                <h3 className="text-xl font-bold">
                  Singapore Management University
                </h3>
                <h3 className="text-l">
                  Bachelor of Science: Computer Science
                </h3>
                <h3 className="text-l text-gray-500">
                  August 2023 - May 2027
                </h3>
                <p className="mt-3 list-item list-inside">
                  Teaching Assistant, Master’s of IT in Business: Data Management (SQL)
                </p>
                <p className="mt-3 list-item list-inside">
                  Training Director, Inter-Varsity Ultimate Frisbee
                </p>
                <p className="mt-3 list-item list-inside">
                  Member, Inter-Varsity Bouldering
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
